export default {
  'SET_TOKEN': 'SET_TOKEN'
}
